export default __webpack_public_path__ + "KaTeX_Typewriter-Regular.d3c8e68f425df650554fab73fd14628f.woff";